export const Values = Object.values
